import React, { useEffect, useContext } from "react";
import { useImmer } from "use-immer";
import { successMessage, errorMessage } from "../../../utils";
import { getEodHistoryList } from "../api";

export const useEndofDayHistory = ({ id }) => {

  const [state, setState] = useImmer({
    isLoading: true,
    dataList: [],
    selectedData: null,
    isModalOpen: false,
  });

  useEffect(() => {
    if (id && state.dataList.length === 0) {
      handleGetEODHistory(id);
    }
  }, [id]);


  const handleGetEODHistory = async (id) => {
    try {
      const res = await getEodHistoryList(id);
      if (res.success) {
        setState((draft) => {
          draft.dataList = res.data;
          draft.isLoading = false;
        });
      } else {
        errorMessage(res.message);
      }
    } catch (err) {
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const handleModal = (isOpen, data) => {
    if (isOpen && data) {
      generateChangesTable(data);
    } else {
      setState((draft) => {
        draft.isModalOpen = isOpen;
        draft.selectedData = null;
      });
    }

  };
  const generateChangesTable = (data) => {
    const changes = data?.properties || [];
    
    // Key to display name mapping
    const keyNameMapping = {
      cash_total: "Cash in Hand",
      system_cash: "System Cash",
      round_off_total: "Round off",
      variance: "Variance",
      cheque_total: "Cheque",
      menulog_sales: "Menulog",
      ubereats_sales: "Uber Eats",
      loyalty_total: "Loyalty",
      gift_card_total: "Gift Card",
      client_account_total: "Client Account",
      card_total: "EFT/Card",
      online_ordering_sales: "Stripe",
      dd_sales: "DoorDash",
      total_tax: "Total Tax",
      float_total: "Float Amount",
      gross_sales: "Gross Sales",
      net_sales: "Net Sales",
      cash_banked_total: "Cash Banked",
      transactions: "Transactions",
      total_wastage_cost_exc_tax: "Total Wastage Cost Ex GST",
      total_discount: "Discount",
      total_refund: "Gross Refund",
      ca_cash: "CA Cash",
      ca_eft: "CA EFT",
      ca_bank_cheque: "CA Cheque",
      ca_bank_transfer: "CA Bank Transfer",
      refund_deduction: "Refund Deduction"
    };

    // Keys that should NOT have $ prefix (non-monetary values)
    const nonMonetaryKeys = ['transactions'];

    // Helper function to format value with $ if it's a monetary field
    const formatValue = (key, value) => {
      
      if (value === null || value === undefined) return "--";
      if (nonMonetaryKeys.includes(key)) return value;

      return `$${value}`; // Format as currency
    };
    
    let result = []
    if (changes.old === null) {
      Object.keys(changes.attributes).forEach((key) => {
        if( changes.attributes[key] !== null && key !== 'gross_avg' && key !== 'net_avg') {
          result.push({
          keys: keyNameMapping[key] || key,
          new: formatValue(key, changes.attributes[key]),
          old: "--"
        });
        }
        
      });
    } else {
      Object.keys(changes.attributes).forEach((key) => {
        if (key !== 'gross_avg' && key !== 'net_avg') {
          result.push({
            keys: keyNameMapping[key] || key,
            new: formatValue(key, changes.attributes[key]),
            old: formatValue(key, changes.old[key])
          });
        }
      });
    }

    setState((draft) => {
      draft.selectedData = result;
      draft.isModalOpen = true;
    });
  };

  return {
    state,
    handleModal
  };
};
